module.exports = __webpack_public_path__ + "img/28_37.269fa5c7.png";